module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image-922b971558c3a538874e7a93c931810e.webp";